import styled from '@emotion/styled'
import { useId, useCallback, forwardRef } from 'react'
import { errorStyles, inputStyles } from 'css/utils'
import { InputContainer, InputContainerProps } from 'modules/ui/atoms/Input/InputContainer'

export interface DateInputProps extends InputContainerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: any
  dataId?: string
  autoFocus?: boolean
  min?: HTMLInputElement['min']
  onFocus?: () => void
}

const StyledDateInput = styled.input(
  {
    minHeight: '40px',
    ...inputStyles,
  },
  errorStyles,
)

export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
  ({ onChange, value, error, dataId = '', autoFocus, min, onFocus, ...props }, ref) => {
    const id = useId()
    const captionId = useId()

    const onChangeCallback = useCallback(
      (e: { target: { value: string } }) => {
        onChange(e.target.value)
      },
      [onChange],
    )

    return (
      <InputContainer {...props} value={value} id={id} captionId={captionId}>
        <StyledDateInput
          type="date"
          onChange={onChangeCallback}
          value={value}
          errored={!!error}
          id={id}
          aria-describedby={captionId}
          data-id={dataId}
          ref={ref}
          autoFocus={autoFocus}
          min={min}
          onFocus={onFocus}
        />
      </InputContainer>
    )
  },
)

DateInput.displayName = 'DateInput'

export default DateInput
